import Basic from '@/layouts/Basic';

const Login = () => import('@/views/login');

const router = [
    {
        path: '/login',
        component: Basic,
        children: [
            {
                path: '',
                name: 'login',
                component: Login,
            },
        ],
    },
];

export default router;
